import { AppLoader } from '@/components/shared/loader'

import { CloseButton } from './CloseButton'

type Props = {
  onClose: () => void
}

export const LoadingSlide = ({ onClose }: Props) => (
  <div className="flex h-full w-full flex-col bg-grey-100 pr-22 pt-20">
    <CloseButton onClick={onClose} />

    <div className="flex flex-1 items-center justify-center">
      <AppLoader noText variant="secondary" />
    </div>
  </div>
)
